import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import Modal from "~/js/common/modal";
import CardName from "./cardName";
import HeaderMenu from "./headerMenu";
import SortStoreItems from "./sortStoreItems";
import Selector from "./selector";
import Stickypin from "~/js/common/stickypin";
import Favorite from "~/js/ec/favorite";
import Tooltip from "~/js/common/tooltip";
import _each from "lodash/each";
export default class CartMain {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
      } else if (mutation.type === "init") {
        this.init();
      } else if (mutation.type === "closeModal") {
        this.hidePointError();
      }
    });

    if (
      navigator.userAgent.indexOf("iPhone") > 0 ||
      navigator.userAgent.indexOf("iPod") > 0 ||
      navigator.userAgent.indexOf("iPad") > 0 ||
      navigator.userAgent.indexOf("Android") > 0 ||
      (/android|ipod|ipad|iphone|macintosh/.test(navigator.userAgent.toLowerCase()) && "ontouchend" in document)
    ) {
      store.dispatch("setIsSP", {
        sta: true
      });
    }

    this.header = new Header();
    this.footer = new Footer();
    this.favorite = new Favorite(document.querySelector(".cart__items"));
    this.modal = new Modal();
    this.headerMenu = new HeaderMenu();
    this.selector = new Selector();
    this.stickyPin = new Stickypin();
    this.tooltip = new Tooltip();
    store.dispatch("init");

    this.setupCheckbox();
    this.setupTermsAgreement();
    this.setupGift();
    this.blurPoint();
    this.setupPoint();

    // DOMが完全に読み込まれた後にポイント促進モーダルを初期化
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.setupPointPrompt();
      });
    } else {
      this.setupPointPrompt();
    }

    this.initPoint();// wl20230302
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
    Common.setupScrollY();
  }

  // チェックボックスの設定
  setupCheckbox() {
    // TODO: 要素がない際にエラーになってしまう部分の修正
    const pointsCheck = document.querySelector(".js-cart-modal-point");
    const giftCheck = document.querySelector(".js-cart-modal-gift");
    if (pointsCheck) {
      pointsCheck.addEventListener("change", (event) => {
        event.preventDefault();

        if (!pointsCheck.checked && pointsCheck.classList.contains('using-point')) {
          pointsCheck.checked = true;
          return false;
        }

        if (pointsCheck.checked) {
          store.dispatch("openModal", {
            name: "cart-point"
          });
          pointsCheck.checked = false;
        } else {
          this.reflectionPoint(0);
          this.reflectionPrice(0);
        }
        ISSEYMIYAKE.Cart.init()
      });
    }
    
    if (giftCheck) {
      giftCheck.addEventListener("change", (event) => {
        event.preventDefault();
        if (giftCheck.checked) {
          store.dispatch("openModal", {
            name: "cart-gift"
          });
          giftCheck.checked = false;
        }
      });
    }
  }

  // ギフトラッピング利用の設定
  setupGift() {
    const useGiftButton = document.querySelector(".js-usegiftbutton");
    const closeButton = document.querySelector(".js-giftmodal-close")
    if (useGiftButton) {
      useGiftButton.addEventListener("click", (e) => {
        const giftSelect = document.querySelector(".js-giftselect");
        const useGift = giftSelect.value;
        this.reflectGift(useGift);
        store.dispatch("closeModal", {
          reason: "enable"
        });
      });
    }
    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault()
        this.reflectGift(0)
        store.dispatch("closeModal")
      })
    }
  }

  // ポイント入力欄からフォーカスが離れた時の処理
  blurPoint() {
    let usePointInput = document.querySelector(".js-usepoint");
    if (usePointInput) {
      usePointInput.addEventListener("blur", () => {
        const inputNum = Math.floor(usePointInput.value / 100) * 100;
        const maxNum = Number(usePointInput.max);

        usePointInput.value = inputNum > maxNum ? maxNum : inputNum;
      });
    }
  }

  // wl20230302
  initPoint() {
    const usePointInput = document.getElementById('_useing_point')
    const usePoint = usePointInput.value;
    if (!this.checkUsePoint(parseInt(usePoint, 10))) {
      this.showPointError();
      return;
    }

    if (usePoint > 0) {
      this.reflectionPoint(usePoint || 0);
      this.reflectionPrice(usePoint || 0);
      const pointsCheck = document.querySelector(".js-cart-modal-point");
      pointsCheck.checked = true;
    }
    ISSEYMIYAKE.Cart.init()
  }

  // ポイント利用の設定
  setupPoint() {
    let usePointButton = document.querySelector(".js-usepointbutton");
    const closeButton = document.querySelector(".js-pointmodal-close")
    if (usePointButton) {
      usePointButton.addEventListener("click", (e) => {
        const usePointInput = document.querySelector(".js-usepoint");
        e.preventDefault();
        const usePoint = usePointInput.value;
        if (!this.checkUsePoint(parseInt(usePoint, 10))) {
          this.showPointError();
          return;
        }

        if (usePoint > 0) {
          this.reflectionPoint(usePoint || 0);
          this.reflectionPrice(usePoint || 0);
          const pointsCheck = document.querySelector(".js-cart-modal-point");
          pointsCheck.checked = true;
        }
        store.dispatch("closeModal", {
          reason: "enable"
        });
        ISSEYMIYAKE.Cart.init()
      });
    }
    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault()
        this.reflectionPoint(0);
        this.reflectionPrice(0);
        store.dispatch("closeModal")
      })
    }
  }

  // ポイント促進モーダルの設定
  async setupPointPrompt() {
    // 定数定義
    const MIN_POINT_THRESHOLD = 100; // ポイント表示の最小閾値
    const MODAL_OPEN_DELAY = 500; // モーダルを開くまでの遅延時間（ミリ秒）
    const POINT_DISPLAY_DELAY = 100; // ポイント表示の遅延時間（ミリ秒）
    const HIDE_DURATION_MS = 24 * 60 * 60 * 1000; // 非表示期間（24時間）

    // テーマ設定チェック（モーダルがレンダリングされていない = 機能OFF）
    const promptModal = document.querySelector('.p-cart-point-prompt-modal');
    if (!promptModal) return;

    // localStorageチェック（24時間以内は表示しない）
    const hiddenData = localStorage.getItem('cartPointPromptHidden');
    if (hiddenData) {
      try {
        const data = JSON.parse(hiddenData);
        if (Date.now() - data.timestamp < HIDE_DURATION_MS) {
          return; // 24時間以内なら表示しない
        }
      } catch (error) {
        console.warn('Failed to parse localStorage data:', error);
        // パースエラーの場合は古いデータを削除
        localStorage.removeItem('cartPointPromptHidden');
      }
    }

    // getCustomer()からポイント数を取得
    let customer;
    try {
      customer = await getCustomer();
      if (!customer) {
        console.warn('Customer data not available');
        return;
      }
    } catch (error) {
      console.error('Failed to fetch customer:', error);
      return;
    }

    const availablePoints = customer.pointBalance ?? 0;
    if (availablePoints < MIN_POINT_THRESHOLD) return;

    // モーダルを表示
    setTimeout(() => {
      store.dispatch("openModal", {
        name: "cart-point-prompt"
      });

      // モーダルが開いた後にポイント数を表示
      setTimeout(() => {
        const pointDisplayDom = document.querySelector(".js-available-point");
        if (pointDisplayDom) {
          pointDisplayDom.innerText = availablePoints.toLocaleString();
        }
      }, POINT_DISPLAY_DELAY);
    }, MODAL_OPEN_DELAY);

    // 閉じるボタンと×アイコンのイベント設定
    const closePromptButton = document.querySelector(".js-close-prompt");
    const closeIconButton = document.querySelector(".p-cart-point-prompt-modal .js-modal-close");
    const hideCheckbox = document.querySelector(".js-hide-prompt-checkbox");

    const handleClose = (e) => {
      e.preventDefault();

      // チェックボックスの状態を確認
      if (hideCheckbox && hideCheckbox.checked) {
        // localStorageに保存
        try {
          localStorage.setItem('cartPointPromptHidden', JSON.stringify({
            timestamp: Date.now()
          }));
        } catch (error) {
          console.error('Failed to save to localStorage:', error);
        }
      }

      store.dispatch("closeModal");
    };

    if (closePromptButton) {
      closePromptButton.addEventListener("click", handleClose);
    }

    if (closeIconButton) {
      closeIconButton.addEventListener("click", handleClose);
    }
  }

  // ギフトラッピング使用の反映
  reflectGift(useGift) {
    const giftCheck = document.querySelector(".js-cart-modal-gift");
    if (useGift == "なし") {
      giftCheck.checked = false;
    }else{
      giftCheck.checked = true;
    }
  }

  // 使用ポイントの数字を反映
  reflectionPoint(usePoint) {
    const pointtexts = document.querySelectorAll(".js-usepoint-text");
    _each(pointtexts, (pointtext) => {
      if (usePoint) {
        pointtext.classList.add("type-attention");
        pointtext.innerText = "-" + Common.addComma(usePoint);
      } else {
        pointtext.classList.remove("type-attention");
        pointtext.innerText = usePoint;
        const check = document.querySelector(".js-cart-modal-point");
        check.checked = false;
      }
      pointtext.setAttribute("data-value", usePoint);
    });
  }
  reflectionPrice(usePoint) {
    const totalPriceDom = document.querySelector(".js-totalprice");
    if (totalPriceDom) {
      const totalPrice = totalPriceDom.getAttribute("data-value");
      totalPriceDom.setAttribute("data-comuted-value", totalPrice - usePoint);
      /**
       * developer: kanehori
       * 価格に円をつける + 3桁区切りに変更
       * Before:
       * totalPriceDom.innerText = Common.addComma(totalPrice - usePoint);
       */
      totalPriceDom.innerText = Common.addComma(totalPrice - usePoint).toLocaleString() + ' 円';
    }
  }

  // 使用可能なポイント数かどうかのチェック
  checkUsePoint(point) {
    const usablePointDom = document.querySelector(".js-usablepoint");
    const totalPriceDom = document.querySelector(".js-totalprice");
    if (usablePointDom) {
      const usablePoint = usablePointDom.getAttribute("data-value");
      if (point > parseInt(usablePoint, 10)) {
        return false;
      }
    } else {
      return false;
    }
    if (totalPriceDom) {
      const totalPrice = totalPriceDom.getAttribute("data-value");
      if (point > parseInt(totalPrice, 10)) {
        return false;
      }
    } else {
      return false;
    }
    return true;
  }

  // ポイントに関するエラー表示
  showPointError() {
    const _dom = document.querySelector(".js-pointerror");
    if (_dom) {
      _dom.classList.add("appear");
    }
  }
  hidePointError() {
    const _dom = document.querySelector(".js-pointerror");
    if (_dom) {
      _dom.classList.remove("appear");
    }
  }

  // 規約同意の設定
  setupTermsAgreement() {
    const wrap = document.querySelector(".js-cart-terms");
    if (!wrap) return; // 機能OFF時は要素がないため何もしない

    const checkbox = wrap.querySelector(".js-terms-agree");
    const agreedAtInput = wrap.querySelector(".js-terms-agreed-at");
    const checkoutBtn = document.querySelector("#checkout[type='submit']");
    const errorDom = document.querySelector("#checkoutError");
    const isDesignMode = wrap.dataset.designMode === "true";

    if (!checkbox || !agreedAtInput) return; // 想定外のマークアップ変更時は対象外
    if (!checkoutBtn) return; // submitボタンがない場合は対象外
    if (isDesignMode) return; // プレビューエディタでは制御をスキップ

    const syncState = () => {
      if (checkbox.checked) {
        agreedAtInput.value = this.buildJstTimestamp();
        checkoutBtn.disabled = false;
        if (errorDom) errorDom.textContent = "";
      } else {
        agreedAtInput.value = "";
        checkoutBtn.disabled = true;
      }
    };

    syncState(); // 初期状態を反映（未チェック → disabled）
    checkbox.addEventListener("change", syncState);

    // 保険: 未チェック時のsubmitを抑止
    const form = document.getElementById("cart");
    if (form) {
      form.addEventListener("submit", (e) => {
        if (!checkbox.checked) {
          e.preventDefault();
          if (errorDom) errorDom.textContent = "利用規約・プライバシーポリシーへの同意が必要です。";
        }
      });
    }
  }

  // JST(+09:00)のISO 8601文字列を生成
  buildJstTimestamp() {
    const now = new Date();
    const jst = new Date(now.getTime() + 9 * 60 * 60 * 1000);
    const p = (n) => String(n).padStart(2, "0");
    return `${jst.getUTCFullYear()}-${p(jst.getUTCMonth() + 1)}-${p(jst.getUTCDate())}` +
      `T${p(jst.getUTCHours())}:${p(jst.getUTCMinutes())}:${p(jst.getUTCSeconds())}+09:00`;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new CartMain();
});
